import styled from 'styled-components';

/** PartnerStrip — ports `.mc-strip` (footer strip pinned to bottom of sidebar). */
const Strip = styled.div`
  margin-top: auto;
  padding: 12px;
  background: ${({ theme }) => theme.color.kInk};
  border-radius: 8px;
  font-size: 11px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #fff;
`;

export function PartnerStrip() {
  return (
    <Strip>
      <span aria-hidden>◆</span>
      <span>Powered by Kindred</span>
    </Strip>
  );
}
